import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AccountShell({ title, children, navItems }) {
  const location = useLocation();

  return (
    <div className="account-shell">
      <style>{`
        .account-shell {
          max-width: 1100px;
          margin: 40px auto;
          padding: 0 20px;
        }

        .account-shell-title {
          margin-bottom: 24px;
        }

        .account-shell-grid {
          display: grid;
          grid-template-columns: 240px 1fr;
          gap: 24px;
        }

        .account-shell-navlink {
          display: block;
          padding: 10px 12px;
          border-radius: 10px;
          margin-bottom: 8px;
          text-decoration: none;
          font-weight: 600;
        }

        .account-shell-content {
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        @media (max-width: 768px) {
          .account-shell {
            margin: 0;
            padding: 72px 14px 28px;
            max-width: none;
            min-height: 100vh;
            overflow-x: hidden;
          }

          .account-shell-title {
            margin: 0 0 18px;
            font-size: 28px;
          }

          .account-shell-grid {
            display: flex;
            flex-direction: column;
            gap: 14px;
          }

          .account-shell-sidebar {
            display: flex;
            gap: 8px;
            overflow-x: auto;
            padding-bottom: 4px;
          }

          .account-shell-navlink {
            flex: 0 0 auto;
            margin-bottom: 0;
            padding: 10px 14px;
            border-radius: 999px;
            background: rgba(251,247,242,0.82);
            border: 1px solid rgba(43,43,43,0.08);
          }

          .account-shell-content {
            width: 100%;
            box-sizing: border-box;
            border-radius: 24px;
            padding: 16px;
            overflow: hidden;
          }
        }
      `}</style>

      <h1 className="account-shell-title">{title}</h1>

      <div className="account-shell-grid">
        <div className="account-shell-sidebar">
          {navItems.map((item) => {
            const active = location.pathname === item.to;

            return (
              <Link
                key={item.to}
                to={item.to}
                className="account-shell-navlink"
                style={{
                  color: active ? "#000" : "#555",
                  background: active
                    ? "rgba(176,140,108,0.12)"
                    : "rgba(251,247,242,0.82)",
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <div className="account-shell-content">{children}</div>
      </div>
    </div>
  );
}